<template>
  <div class="select-panel">
    <div
      class="panel panel-left"
      :class="{ small: form.audience.region == '按区县' }"
    >
      <div class="panel-header">{{ title }}</div>
      <div class="panel-container">
        <el-cascader-panel
          ref="cascader"
          v-model="form.audience.regionArr"
          :border="false"
          :options="citys"
          :props="{
            label: 'name',
            value: 'name',
            multiple: true,
            emitPath: false,
          }"
        ></el-cascader-panel>
      </div>
    </div>
    <div
      class="panel panel-right"
      :class="{ small: form.audience.region == '按区县' }"
    >
      <div class="panel-header">
        已选<span
          class="clear"
          v-if="form.audience.regionArr.length > 0"
          @click="$refs.cascader.clearCheckedNodes()"
          >清空</span
        >
      </div>
      <div class="panel-container">
        <div class="panel-none" v-if="form.audience.regionArr.length == 0">
          <el-image
            class="img"
            :src="require(`@/assets/images/simulation/icon_empty.svg`)"
            fit="fit"
          ></el-image>
        </div>
        <div v-else>
          <div
            class="item-selected"
            v-for="(item, idx) in form.audience.regionArr"
            :key="idx"
          >
            <span class="item-name">{{ item }}</span>
            <i class="el-icon-close" @click="handleDelItem(item)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object,
    citys: Array,
    title: String,
  },
  methods: {
    handleDelItem(city) {
      let newArr = this.form.audience.regionArr.filter((item) => {
        return item != city;
      });
      this.form.audience.regionArr = newArr;
    },
  },
};
</script>

<style lang="less" scoped>
.select-panel {
  .panel {
    display: inline-block;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
    vertical-align: top;
    &.panel-left {
      margin-right: 16px;
      width: calc(100% - 216px);
      &.small {
        width: calc(100% - 183px);
      }
    }
    &.panel-right {
      width: 200px;
      &.small {
        width: 167px;
      }
    }
    .panel-header {
      padding: 8px 12px;
      border-bottom: 1px solid #e0e0e0;
      background-color: #fafafa;
      color: #333;
      font-weight: 700;
      font-size: 14px;
      line-height: 22px;
      overflow: hidden;
      .clear {
        float: right;
        font-weight: normal;
        color: #194ce5;
        cursor: pointer;
      }
    }
    .panel-container {
      position: relative;
      height: 192px;
      padding: 6px 0;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #c8c8c8;
      }

      ::v-deep .el-cascader-panel {
        .el-cascader-menu {
          flex: 1;
          .el-cascader-node {
            &.is-active {
              color: inherit;
              font-weight: normal;
            }
            &.in-active-path {
              color: #194ce5;
            }
            .el-checkbox {
              .el-checkbox__inner {
                width: 16px;
                height: 16px;
              }
              &.is-checked {
                .el-checkbox__inner {
                  background-color: #333;
                  border-color: #333;
                  &::after {
                    left: 5px;
                  }
                }
              }
              .is-indeterminate {
                .el-checkbox__inner {
                  background-color: #333;
                  border-color: #333;
                }
              }
            }
          }
        }
        .el-cascader-menu__wrap {
          height: 192px;
        }
      }
      .panel-none {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      .item-selected {
        position: relative;
        margin: 8px 12px;
        padding: 2px 8px;
        background-color: #f0f0f0;
        border-radius: 4px;
        .item-name {
          display: block;
          margin-right: 14px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          line-height: 22px;
          font-size: 14px;
          color: #333;
          font-weight: 400;
          cursor: pointer;
        }
        .el-icon-close {
          position: absolute;
          right: 8px;
          top: 12px;
          line-height: 0;
          cursor: pointer;
        }
      }
    }
  }
}
</style>